import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from "react-router-dom";
import { Alert, Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row, Col } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as elements from '../data/Elements';
import * as Records from '../store/Records';
import * as Sponsors from '../store/Sponsors';
import * as Studies from '../store/Studies';
import * as utility from '../data/Utility';
import StudyComplianceSchedule from './EditStudyComplianceSchedule';

const endDateId = "endDate";
const endTimeId = "endTime";
const startDateId = "startDate";
const startTimeId = "startTime";

class CreateStudyInternal extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, true);
        const editing = utility.propCheck(props.editing, true);
        const sponsor = utility.propCheck(props.sponsor, null);
        const sponsorId = utility.propCheck(props.sponsorId, "");
        const studyId = utility.propCheck(props.studyId, "");
        const timeZone = utility.getTimeZone();

        this.state = {
            create: create,
            editing: editing,
            error: false,
            sponsor: sponsor,
            sponsorId: sponsorId,
            studyId: studyId,
            timeZone: timeZone
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleCode = this.handleCode.bind(this);
        this.handleEndDate = this.handleEndDate.bind(this);
        this.handleEndTime = this.handleEndTime.bind(this);
        this.handleName = this.handleName.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleStartDate = this.handleStartDate.bind(this);
        this.handleStartTime = this.handleStartTime.bind(this);
        this.handleCrfAnswer = this.handleCrfAnswer.bind(this);
        this.handleServiceType = this.handleServiceType.bind(this);
        this.handleComplianceSchedule = this.handleComplianceSchedule.bind(this);
        this.handlePriceEachServiceType = this.handlePriceEachServiceType.bind(this);
        this.handleDeleteCrfQuestion = this.handleDeleteCrfQuestion.bind(this);
        this.initialize = this.initialize.bind(this);

    }

    checkCrfQnA(crfQnA, theServiceType) {
        if (typeof crfQnA === 'string' || crfQnA instanceof String) {
            crfQnA = JSON.parse(crfQnA);

            const study = this.props.studiesState.study;
            if (!study) {
                return crfQnA;
            }
            switch (theServiceType) {
                case Records.recordServiceTypes.event:
                    study.crfQnaEvent = crfQnA;
                    break;
                case Records.recordServiceTypes.holter:
                    study.crfQnaHolter = crfQnA;
                    break;
                case Records.recordServiceTypes.twelveLead:
                    study.crfQna12Lead = crfQnA;
                    break;
                default:
                    break;
            }
            this.props.studiesDispatch.set(study);
        }
        return crfQnA;
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(false);
    }

    componentDidUpdate() {
        const sponsor = this.props.sponsorsState.sponsor;
        if (this.state.sponsor == null &&
            sponsor != null) {
            this.setState({
                sponsor: sponsor
            });
        }
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.push(paths.home);
        }
        else {
            const sponsor = this.props.sponsorsState.sponsor;
            if (sponsor != null) {
                this.setState({
                    sponsor: null,
                    sponsorId: sponsor.id
                });
            }
            this.initialize(true);
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }

            document.getElementById(endDateId).value = "";
            document.getElementById(endTimeId).value = "";
            document.getElementById(startDateId).value = "";
            document.getElementById(startTimeId).value = "";
        }
    }

    handleCode(e) {
        const study = this.props.studiesState.study;
        study.code = e.target.value;
        this.props.studiesDispatch.set(study);
    }

    handleEndDate(e) {
        const study = this.props.studiesState.study;
        study.endDateTime = utility.getDateTimeFromInputDate(e.target.value, study.endDateTime);
        this.props.studiesDispatch.set(study);
    }

    handleEndTime(e) {
        const study = this.props.studiesState.study;
        study.endDateTime = utility.getDateTimeFromInputTime(e.target.value, study.endDateTime);
        this.props.studiesDispatch.set(study);
    }

    /* store the type of multipe choice answer for this question */
    handleWhichAnswerType(theServiceType, idx, theAnswerType) {
        var crfQnA = [];
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        theAnswerType = theAnswerType && theAnswerType[0];
        crfQnA[idx].multipleChoicesType = theAnswerType;
        this.props.studiesDispatch.set(study);
    }

    handleCrfAnswer(theServiceType, questionId, idx, e) {
        this.updateCrfField(theServiceType, questionId, idx % 10, e.target.value);
    }

    handleServiceType(theServiceType, e) {
        const isChecked = e.target.checked;
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                study.isServiceEvent = isChecked;
                break;
            case Records.recordServiceTypes.holter:
                study.isServiceHolter = isChecked;
                break;
            case Records.recordServiceTypes.twelveLead:
                study.isService12Lead = isChecked;
                break;
            default:
                break;
        }

        this.props.studiesDispatch.set(study);
    }

    handleComplianceSchedule( type, value ) {

		this.setState({ [type]: value });

		switch ( type ) {
			case Studies.SchedCompType.allCompSchedules:
			case Studies.SchedCompType.blankingPeriodDays:
			case Studies.SchedCompType.length12Lead:
			case Studies.SchedCompType.lengthEvent:
			case Studies.SchedCompType.lengthHolter:
				this.props.studiesDispatch.setScheduling( type, value );
				break;

			default:
				break;
		}

	}

    handlePriceEachServiceType(theServiceType, e) {
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

		/* this validation only allows real numbers to be entered */
		if ( /^[0-9]*\.?[0-9]*$/.test(e.target.value) ) {
			switch (theServiceType) {
				case Records.recordServiceTypes.event:
					study.priceEvent = e.target.value;
					break;
				case Records.recordServiceTypes.holter:
					study.priceHolter = e.target.value;
					break;
				case Records.recordServiceTypes.twelveLead:
					study.price12lead = e.target.value;
					break;
				default:
					break;
			}
        }

        this.props.studiesDispatch.set(study);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

    handleName(e) {
        const study = this.props.studiesState.study;
        study.name = e.target.value;
        this.props.studiesDispatch.set(study);
    }

    handleSave() {
        const sponsor = this.state.sponsor;
        const study = this.props.studiesState.study;

        if (sponsor == null ||
            study.name === "") {
            this.setState({
                error: true
            });
        }
        else {
            this.setState({
                error: false
            });

            if (this.state.create) {
                this.props.studiesDispatch.create(sponsor.id);
                this.props.history.push(paths.home);
            }
            else {
                (async () => {
                    await this.props.studiesDispatch.update(sponsor.id);
                })().then(() => {
                    this.props.history.push(paths.manageStudies);
                });
            }
        }
    }

    onAddFunc(theServiceType) {
        this.addQuestion(theServiceType);
        this.forceUpdate();
    }

    handleDeleteCrfQuestion(theServiceType, idx, e) {
        this.deleteQuestion(theServiceType, idx);
        this.forceUpdate();
    }

    handleStartDate(e) {
        const study = this.props.studiesState.study;
        study.startDateTime = utility.getDateTimeFromInputDate(e.target.value, study.startDateTime);
        this.props.studiesDispatch.set(study);
    }

    handleStartTime(e) {
        const study = this.props.studiesState.study;
        study.startDateTime = utility.getDateTimeFromInputTime(e.target.value, study.startDateTime);
        this.props.studiesDispatch.set(study);
    }

    isIdInCrfQnA(theServiceType, theCrfId) {
        var crfQnA = [];
        let isFound = false;
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        crfQnA.find((o, idx) => {
            if (o.id === theCrfId) {
                isFound = true;
                return true;	// stop searching
            }
            else {
                return false;	// keep looking
            }
        });

        return isFound;
    }


    addQuestion(theServiceType) {
        var crfQnA = [];
        let nextAvailableIdx = -1;
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                if (study.crfQnaEvent == null) {
                    study.crfQnaEvent = [];
                }
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                if (study.crfQnaHolter == null) {
                    study.crfQnaHolter = [];
                }
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                if (study.crfQna12Lead == null) {
                    study.crfQna12Lead = [];
                }
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        for (var i = 0; i < crfQnA.length; i++) {
            if (!this.isIdInCrfQnA(theServiceType, i)) {
                nextAvailableIdx = i;
                break;
            }
        }

        if (nextAvailableIdx === -1) {
            nextAvailableIdx = crfQnA.length;
        }

        crfQnA.push({
            id: nextAvailableIdx,
            serviceType: theServiceType,
            questionText: null,
            answerText: null,
            multipleChoices: null,
            dependsOnWhichId: -1,
            hideWhenAnswerIs: null,
        });
    }

    deleteQuestion(theServiceType, theQuestionIdx) {
        var crfQnA = [];
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        var idxToDelete = -1;
        for (var i = 0; i < crfQnA.length; i++) {
            if (crfQnA[i].id === theQuestionIdx) {
                idxToDelete = i;
            }
        }

        if (idxToDelete >= 0) {
            crfQnA.splice(idxToDelete, 1);
        }
    }

    updateCrfField(theServiceType, idxQuestion, whichField, val) {
        var crfQnA = [];
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        var theQ = crfQnA[idxQuestion];

        switch (whichField) {
            case 0:
                theQ.questionText = val;
                break;
            case 1:
                theQ.multipleChoices = val;
                break;
            case 2:
                if ((val.trim().length === 0)) {
                    theQ.dependsOnWhichId = -1;
                }
                else {
                    if (!isNaN(parseInt(val, 10))) {
                        theQ.dependsOnWhichId = parseInt(val, 10) - 1;
                    }
                }
                break;
            case 3:
                theQ.hideWhenAnswerIs = val;
                break;
            default:
                break;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                study.crfQnaEvent = crfQnA;
                break;
            case Records.recordServiceTypes.holter:
                study.crfQnaHolter = crfQnA;
                break;
            case Records.recordServiceTypes.twelveLead:
                study.crfQna12Lead = crfQnA;
                break;
            default:
                break;
        }
        this.props.studiesDispatch.set(study);
    }

    retrieveQaQuestionAnswers(theServiceType) {
        var crfQnA = [];
        const study = this.props.studiesState.study;

        if (!study) {
            return;
        }

        switch (theServiceType) {
            case Records.recordServiceTypes.event:
                crfQnA = study.crfQnaEvent;
                break;
            case Records.recordServiceTypes.holter:
                crfQnA = study.crfQnaHolter;
                break;
            case Records.recordServiceTypes.twelveLead:
                crfQnA = study.crfQna12Lead;
                break;
            default:
                break;
        }

        crfQnA = this.checkCrfQnA(crfQnA, theServiceType);
        return crfQnA && crfQnA.sort((a, b) => { return a.id - b.id; });
    }


    getAllQaQuestionAnswers(theServiceType, isDisabled) {
        const classNameInput = "crfDependency crfAnswerParent";
        const crfQnA = this.retrieveQaQuestionAnswers(theServiceType);
        var outerClassName = "";
        var toggleColor = 0;

        return crfQnA && crfQnA.map(function (theCrf, idx) {
            var strDependsOn = "";
            if (theCrf.dependsOnWhichId >= 0) {
                strDependsOn = theCrf.dependsOnWhichId + 1;
            }

            if (toggleColor === 0) {
                toggleColor = 1;
                outerClassName = " light";
            }
            else {
                toggleColor = 0;
                outerClassName = " dark";
            }

            var inputs = [];
            var isHidden = false;
            const magicConstantThatWillNotStepOnQuestionId = 1000;
            const questionId = magicConstantThatWillNotStepOnQuestionId * theCrf.id;
            const selections = Object.keys(elements.multipleChoiceTypes).map((k) => elements.multipleChoiceTypes[k]);
            var selectionsValues = null;
            const slct = (e) => this.handleWhichAnswerType(theServiceType, idx, e);

            if (theCrf.multipleChoicesType != null) {
                selectionsValues = [];
                selectionsValues.push(theCrf.multipleChoicesType);
            }

            inputs.push(elements.getInputForCRF(theServiceType + '_questionText' + questionId + 0, "Question: ", isDisabled, isHidden, classNameInput, null, (e) => this.handleCrfAnswer(theServiceType, theCrf.id, 0, e), this.handleKeyDown, elements.inputTypes.text, theCrf.questionText, null, null));
            inputs.push(elements.getInputForCRF(theServiceType + '_multipleChoices' + questionId + 1, "Multiple Choices (separated by | symbols): ", isDisabled, isHidden, classNameInput, slct, (e) => this.handleCrfAnswer(theServiceType, theCrf.id, 1, e), this.handleKeyDown, elements.inputTypes.text, theCrf.multipleChoices, selections, selectionsValues));
            inputs.push(elements.getInputForCRF(theServiceType + '_dependsOnWhichId' + questionId + 2, "Depends on which other question: ", isDisabled, isHidden, classNameInput, null, (e) => this.handleCrfAnswer(theServiceType, theCrf.id, 2, e), this.handleKeyDown, elements.inputTypes.text, strDependsOn, null, null));
            inputs.push(elements.getInputForCRF(theServiceType + '_hideWhenAnswerIs' + questionId + 3, "Hidden for which answer on that question: ", isDisabled, isHidden, classNameInput, null, (e) => this.handleCrfAnswer(theServiceType, theCrf.id, 3, e), this.handleKeyDown, elements.inputTypes.text, theCrf.hideWhenAnswerIs, null, null));

            return elements.getCrfGroup(theServiceType + " Question " + (theCrf.id + 1) + ":", outerClassName, false, inputs, (e) => this.handleDeleteCrfQuestion(theServiceType, theCrf.id, e), isDisabled);
        }, this);
    }


    initialize(cancel) {

        if (cancel || this.state.sponsor == null) {
            if (this.state.create) {
                const study = JSON.parse(JSON.stringify(Studies.emptyStudy));
                this.props.studiesDispatch.set(study);
            }
            else {

				(async () => {
					await this.props.studiesDispatch.get(this.state.studyId);
					await this.props.sponsorsDispatch.get(this.state.sponsorId);
					// await this.props.studiesDispatch.getAllCompSchedules(this.state.studyId);
				})().then(() => {
				});
            }
        }
    }

    /* If any patients have been added to this study, then this should return false, otherwise true. */
    isEditingAllowed(studyId) {
        if (studyId == null) {
            return false;
        }
        const allStudies = this.props.studiesState && this.props.studiesState.all;
        const thisStudy = allStudies.find(function (s) { return s.id === studyId });

        return !thisStudy.isLocked;
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }
		const authenticatedAccount = this.props.accountsState.authenticatedAccount;
		// const isBillingRole = ( (authenticatedAccount != null) && (authenticatedAccount.role === Accounts.accountRoles.Billing) ); // DEBUG: use this line instead once the Billing role is enabled in the API
		const isBillingRole = ( (authenticatedAccount != null) && (authenticatedAccount.role === Accounts.accountRoles.Administrator) );

        const study = this.props.studiesState.study;
        const cancel = "Cancel";
        const create = this.state.create;
        var code = "";
        var displayEditLink = false;
        const editing = this.state.editing;
        var endDate = "";
        var endTime = "";
        var isServiceEvent = false;
        var isServiceHolter = false;
        var isService12Lead = false;
		let priceEvent = (study) ? study.priceEvent : '';
		let priceHolter = (study) ? study.priceHolter : '';
		let price12lead = (study) ? study.price12lead : '';
		const classNamePriceEach = "crfDependency crfAnswerParent";
        const linkTitle = "Link";
        var name = "";
        const optional = " - Optional";
        const save = "Save";
        const sponsor = this.state.sponsor;
        var sponsorName = "";
        var startDate = "";
        var startTime = "";
        const timeZone = this.state.timeZone;
        var title = "Create Study";

        if (!create) {
            if (editing) {
                title = "Edit Study";
            }
            else {
                displayEditLink = this.isEditingAllowed(study && study.id);
                title = "Study";
            }

			if ( ! this.props.studiesState.study ) {
				const alertColor = "primary";
				const message = "No study information yet...";
				return <div className="autoScheduler crfTitle">
					<h1> {title} </h1>
					<Alert color={alertColor}>{message}</Alert>
				</div>;
			}
        }

        if (study != null) {
            if (study.code != null) {
                code = study.code;
            }
            if (study.endDateTime != null) {
                endDate = utility.formatInputDate(study.endDateTime);
                endTime = utility.formatInputTime(study.endDateTime);
            }
            if (study.isServiceEvent != null) {
                isServiceEvent = study.isServiceEvent;
            }
            if (study.isServiceHolter != null) {
                isServiceHolter = study.isServiceHolter;
            }
            if (study.isService12Lead != null) {
                isService12Lead = study.isService12Lead;
            }
            if (study.name != null) {
                name = study.name;
            }
            if (study.startDateTime != null) {
                startDate = utility.formatInputDate(study.startDateTime);
                startTime = utility.formatInputTime(study.startDateTime);
            }
        }

        if (sponsor != null &&
            sponsor.name != null) {
            sponsorName = sponsor.name;
        }
        const displaySponsor = sponsorName !== "";

		let allCompSchedules = { "Event": "", "Holter": "", "12-Lead": "" };
		if ( this.props.studiesState.study && this.props.studiesState.study.allCompSchedules ) {
			allCompSchedules = this.props.studiesState.study.allCompSchedules;
			if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
				allCompSchedules = JSON.parse(allCompSchedules);
			}
		}

        const CheckboxesServiceType = () => {
            return (
                <div className="crf gap-bottom" >
                    {elements.getCheckboxInput("choice_" + Records.recordServiceTypes.event, isServiceEvent, !editing, (evt) => this.handleServiceType(Records.recordServiceTypes.event, evt), this.state.handleKeyDown, Records.recordServiceTypes.event)}
                    {elements.getCheckboxInput("choice_" + Records.recordServiceTypes.holter, isServiceHolter, !editing, (evt) => this.handleServiceType(Records.recordServiceTypes.holter, evt), this.state.handleKeyDown, Records.recordServiceTypes.holter)}
                    {elements.getCheckboxInput("choice_" + Records.recordServiceTypes.twelveLead, isService12Lead, !editing, (evt) => this.handleServiceType(Records.recordServiceTypes.twelveLead, evt), this.state.handleKeyDown, Records.recordServiceTypes.twelveLead)}
                </div>
            );
        };

        return (
            <Form>
                <h1>{title} {displayEditLink && <Button className="button-link" onClick={() => this.setState({ editing: this.isEditingAllowed(study && study.id) })}>(Edit)</Button>}</h1>
                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}

                <FormGroup>
                    <Label for="nameInput">Name</Label>
                    <Input className="input" disabled={!editing} id="nameInput" onChange={this.handleName} onKeyDown={this.handleKeyDown} type="text" value={name} />
                </FormGroup>
                <FormGroup>
                    <Label for="codeInput">Code<i><small>{optional}</small></i></Label>
                    <Input className="input" disabled={!editing} id="codeInput" onChange={this.handleCode} onKeyDown={this.handleKeyDown} type="text" value={code} />
                </FormGroup>
                <FormGroup>
                    <Label for="startDate">Start DateTime ({timeZone})<i><small>{optional}</small></i></Label>
                    <Input className="input" disabled={!editing} id={startDateId} onChange={this.handleStartDate} onKeyDown={this.handleKeyDown} type="date" value={startDate} />
                    <Input className="input" disabled={!editing} id={startTimeId} onChange={this.handleStartTime} onKeyDown={this.handleKeyDown} type="time" value={startTime} />
                </FormGroup>
                <FormGroup>
                    <Label for="endDate">End DateTime ({timeZone})<i><small>{optional}</small></i></Label>
                    <Input className="input" disabled={!editing} id={endDateId} onChange={this.handleEndDate} onKeyDown={this.handleKeyDown} type="date" value={endDate} />
                    <Input className="input" disabled={!editing} id={endTimeId} onChange={this.handleEndTime} onKeyDown={this.handleKeyDown} type="time" value={endTime} />
                </FormGroup>
                <div>
                    <Label for="sponsorInput">Sponsor</Label>
                    {displaySponsor && (
                        <InputGroup>
                            <Input className="input" disabled id="sponsorInput" type="text" value={sponsorName} />
                            <InputGroupAddon addonType="append">
                                <Button aria-label="Close" className="button" close={true} disabled={!editing} onClick={() => this.setState({ sponsor: null })} outline>
                                    <span aria-hidden="true">&times;</span>
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    )}
                    <br />
                    <Button className="button" disabled={!editing} tag={Link} title={linkTitle} to={{ pathname: paths.linkSponsor, state: { createStudy: create, linkToStudy: true, studyId: this.state.studyId, studyName: name } }}>{linkTitle}</Button>
                </div>
                <div className="group-border button-gap">
                    <h2 className="crfTitle">Service Types Used</h2>
                    <CheckboxesServiceType />
                </div>

				{isBillingRole &&
                <div className="group-border button-gap">
                    <h2 className="crfTitle">Price for each Service Type</h2>

					<div className="crf gap-bottom" >
						<Row key={"key_" + Records.recordServiceTypes.event}>
							<Col lg="4">
								<Label for={"lbl_" + Records.recordServiceTypes.event}>{Records.recordServiceTypes.event + " Price: "}</Label>
							</Col>
							<Col>
								<Input id={Records.recordServiceTypes.event + " Price: "} key={Records.recordServiceTypes.event + " Price: "} readOnly={!editing} disabled={!editing} className={classNamePriceEach} onChange={(evt) => this.handlePriceEachServiceType(Records.recordServiceTypes.event, evt)} onKeyDown={this.handleKeyDown} type={elements.inputTypes.text} value={priceEvent} />
							</Col>
						</Row>
						<Row key={"key_" + Records.recordServiceTypes.holter}>
							<Col lg="4">
								<Label for={"lbl_" + Records.recordServiceTypes.holter}>{Records.recordServiceTypes.holter + " Price: "}</Label>
							</Col>
							<Col>
						<Input id={Records.recordServiceTypes.holter + " Price: "} key={Records.recordServiceTypes.holter + " Price: "} readOnly={!editing} disabled={!editing} className={classNamePriceEach} onChange={(evt) => this.handlePriceEachServiceType(Records.recordServiceTypes.holter, evt)} onKeyDown={this.handleKeyDown} type={elements.inputTypes.text} value={priceHolter} />
							</Col>
						</Row>
						<Row key={"key_" + Records.recordServiceTypes.twelveLead}>
							<Col lg="4">
								<Label for={"lbl_" + Records.recordServiceTypes.twelveLead}>{Records.recordServiceTypes.twelveLead + " Price: "}</Label>
							</Col>
							<Col>
						<Input id={Records.recordServiceTypes.twelveLead + " Price: "} key={Records.recordServiceTypes.twelveLead + " Price: "} readOnly={!editing} disabled={!editing} className={classNamePriceEach} onChange={(evt) => this.handlePriceEachServiceType(Records.recordServiceTypes.twelveLead, evt)} onKeyDown={this.handleKeyDown} type={elements.inputTypes.text} value={price12lead} />
							</Col>
						</Row>
					</div>
                </div>
				}

                <div className="group-border button-gap">
                    <h2 className="crfTitle">CRF Questions for {Records.recordServiceTypes.event} Records</h2>
                    <div className="dark">
                        <Button className="button addButton" disabled={!editing || !isServiceEvent} onClick={this.onAddFunc.bind(this, Records.recordServiceTypes.event)}>Add</Button>
                    </div>
                    {this.getAllQaQuestionAnswers(Records.recordServiceTypes.event, !editing)}
                </div>
                <div className="group-border button-gap">
                    <h2 className="crfTitle">CRF Questions for {Records.recordServiceTypes.holter} Records</h2>
                    <div className="dark">
                        <Button className="button addButton" disabled={!editing || !isServiceHolter} onClick={this.onAddFunc.bind(this, Records.recordServiceTypes.holter)}>Add</Button>
                    </div>
                    {this.getAllQaQuestionAnswers(Records.recordServiceTypes.holter, !editing)}
                </div>
                <div className="group-border button-gap">
                    <h2 className="crfTitle">CRF Questions for {Records.recordServiceTypes.twelveLead} Records</h2>
                    <div className="dark">
                        <Button className="button addButton" disabled={!editing || !isService12Lead} onClick={this.onAddFunc.bind(this, Records.recordServiceTypes.twelveLead)}>Add</Button>
                    </div>
                    {this.getAllQaQuestionAnswers(Records.recordServiceTypes.twelveLead, !editing)}
                </div>

                <div className="group-border button-gap">
					<StudyComplianceSchedule studyId={this.state.studyId} allCompSchedules={allCompSchedules} create={create} disabled={!editing} onChange={this.handleComplianceSchedule} />
                </div>

                {editing && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                )}
            </Form>
        );
    }
}

const CreateStudyConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sponsorsState: state.sponsors,
        studiesState: state.studies
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sponsorsDispatch: bindActionCreators(Sponsors.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch)
    })
)(CreateStudyInternal));

export default class CreateStudy extends React.Component {
    render() {
        var create = true;
        var editing = true;
        var sponsor = null;
        var sponsorId = "";
        var studyId = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            create = utility.propCheck(propsState.create, create);
            editing = utility.propCheck(propsState.editing, editing);
            sponsor = utility.propCheck(propsState.sponsor, sponsor);
            sponsorId = utility.propCheck(propsState.sponsorId, sponsorId);
            studyId = utility.propCheck(propsState.studyId, studyId);
        }

        return (
            <ErrorBoundary>
                <CreateStudyConnect create={create} editing={editing} sponsor={sponsor} sponsorId={sponsorId} studyId={studyId} />
            </ErrorBoundary>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/CreateStudy.js